<template>
    <div :class="itemClass" @click="handleClick">
        <span v-if="showRadio" class="radio" />
        <img :src="getBizTypeImage(payChannel)" />
    </div>
</template>

<script>
export default {
    name: 'PayChannelItem',
    props: {
        // 支付渠道
        payChannel: {
            type: String,
            required: true
        },
        // 是否显示单选框
        showRadio: {
            type: Boolean,
            default: true
        },
        // 是否选中
        checked: {
            type: Boolean,
            required: false
        },
        // 是否禁用
        disabled: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        /**
         * item类名
         * @return {string}
         */
        itemClass() {
            return {
                'pay-channel-item': true,
                'is-checked': this.checked,
                'is-disabled': this.disabled
            };
        }
    },
    methods: {
        getBizTypeImage(payChannel) {
            if (!payChannel) {
                return require('@/assets/images/newPay/PC_PAY.png');
            }
            try {
                return require(`@/assets/images/newPay/${payChannel}.png`);
            } catch (e) {
                return require('@/assets/images/newPay/PC_PAY.png');
            }
        },
        /**
         * 处理点击事件
         */
        handleClick() {
            if (this.disabled) {
                return;
            }
            this.$emit('change', this.payChannel, !this.checked);
        }
    }
};
</script>

<style lang="scss" scoped>
.pay-channel-item {
    display: flex;
    align-items: center;
    border: 1px solid #d8dce6;
    cursor: pointer;

    &:hover {
        border: 1px solid #409eff;
    }

    img {
        display: block;
        width: 150px;
        height: 44px;
    }

    .radio {
        position: relative;
        box-sizing: border-box;
        width: 16px;
        height: 16px;
        margin: 0 2px 0 16px;
        background-color: #f0f2f5;
        border: 1px solid #d5d8de;
        border-radius: 100%;
    }
}

.pay-channel-item.is-checked {
    .radio {
        background: #409eff;
        border-color: #409eff;

        &::after {
            position: absolute;
            top: 50%;
            left: 50%;
            width: 4px;
            height: 4px;
            background-color: #fff;
            border-radius: 100%;
            transform: translate(-50%, -50%);
            content: '';
        }
    }
}

.pay-channel-item.is-disabled {
    border-color: #d8dce6;
    cursor: not-allowed;

    .radio {
        background-color: #f0f2f5;
        border-color: #d5d8de;
    }
}
</style>
